import "./Loader.css"
const Loader = () => {
  return (
    <div className="h-screen w-full flex items-center justify-center fixed top-0 left-0 bg-white">
        <div className="spinner"/>
    </div>
  )
}

export default Loader